import { withRouter } from 'react-router';

import {
  changeCampaignLines,
  toggleAllCampaignLinesExpansion,
  toggleCreativesVisibility,
} from './actions';
import CampaignLinesTableHeader from './CampaignLinesTableHeader';
import { connectEditor } from './connect-editor';
import { isExpanded, isSelectable, isSelected } from './utils';

const getId = line => line.id;

// Provide the location as prop, in order to bust the should component render cache
export default withRouter(
  connectEditor(
    ({
      campaignLinesById,
      campaignUI: { areCreativesVisible, expansionStateByLabel },
    }) => {
      const campaignLines = Object.values(campaignLinesById);

      const editableCampaignLines = campaignLines.filter(isSelectable);
      const expandableLines = Object.entries(expansionStateByLabel).map(
        ([label, expanded]) => ({ label, expanded }),
      );

      return {
        areCreativesVisible,
        editableCampaignLines,
        selectedCampaignLines: editableCampaignLines.filter(isSelected),
        expandableLines,
        expandedLines: expandableLines.filter(isExpanded),
      };
    },
    {
      changeCampaignLines,
      toggleAllCampaignLinesExpansion,
      toggleCreativesVisibility,
    },
    (stateProps, dispatchProps, ownProps) => ({
      ...ownProps,
      ...stateProps,
      onToggleLines: selected =>
        dispatchProps.changeCampaignLines(
          stateProps.editableCampaignLines.map(getId),
          'selected',
          selected,
        ),
      onToggleAllExpansions: dispatchProps.toggleAllCampaignLinesExpansion,
      onToggleCreativesVisibility: dispatchProps.toggleCreativesVisibility,
    }),
  )(CampaignLinesTableHeader),
);
